export const cities_data = {
  data: [
    {
      city_id: "01",
      province: "اردبيل",
      city: "اردبيل",
      province_id: "24",
    },
    {
      city_id: "11",
      province: "اردبيل",
      city: "اصلاندوز",
      province_id: "24",
    },
    {
      city_id: "02",
      province: "اردبيل",
      city: "بيله سوار",
      province_id: "24",
    },
    {
      city_id: "06",
      province: "اردبيل",
      city: "پارس آباد",
      province_id: "24",
    },
    {
      city_id: "03",
      province: "اردبيل",
      city: "خلخال",
      province_id: "24",
    },
    {
      city_id: "10",
      province: "اردبيل",
      city: "سرعين",
      province_id: "24",
    },
    {
      city_id: "07",
      province: "اردبيل",
      city: "كوثر",
      province_id: "24",
    },
    {
      city_id: "05",
      province: "اردبيل",
      city: "گرمی",
      province_id: "24",
    },
    {
      city_id: "04",
      province: "اردبيل",
      city: "مشگين شهر",
      province_id: "24",
    },
    {
      city_id: "08",
      province: "اردبيل",
      city: "نمين",
      province_id: "24",
    },
    {
      city_id: "09",
      province: "اردبيل",
      city: "نير",
      province_id: "24",
    },
    {
      city_id: "01",
      province: "اصفهان",
      city: "اردستان",
      province_id: "10",
    },
    {
      city_id: "02",
      province: "اصفهان",
      city: "اصفهان",
      province_id: "10",
    },
    {
      city_id: "18",
      province: "اصفهان",
      city: "آران وبيدگل",
      province_id: "10",
    },
    {
      city_id: "22",
      province: "اصفهان",
      city: "برخوار",
      province_id: "10",
    },
    {
      city_id: "24",
      province: "اصفهان",
      city: "بو يين و مياندشت",
      province_id: "10",
    },
    {
      city_id: "19",
      province: "اصفهان",
      city: "تيران وکرون",
      province_id: "10",
    },
    {
      city_id: "20",
      province: "اصفهان",
      city: "چادگان",
      province_id: "10",
    },
    {
      city_id: "03",
      province: "اصفهان",
      city: "خميني شهر",
      province_id: "10",
    },
    {
      city_id: "04",
      province: "اصفهان",
      city: "خوانسار",
      province_id: "10",
    },
    {
      city_id: "23",
      province: "اصفهان",
      city: "خور و بيابانک",
      province_id: "10",
    },
    {
      city_id: "21",
      province: "اصفهان",
      city: "دهاقان",
      province_id: "10",
    },
    {
      city_id: "05",
      province: "اصفهان",
      city: "سميرم",
      province_id: "10",
    },
    {
      city_id: "16",
      province: "اصفهان",
      city: "شاهين شهروميمه",
      province_id: "10",
    },
    {
      city_id: "09",
      province: "اصفهان",
      city: "شهرضا",
      province_id: "10",
    },
    {
      city_id: "06",
      province: "اصفهان",
      city: "فريدن",
      province_id: "10",
    },
    {
      city_id: "07",
      province: "اصفهان",
      city: "فريدونشهر",
      province_id: "10",
    },
    {
      city_id: "08",
      province: "اصفهان",
      city: "فلاورجان",
      province_id: "10",
    },
    {
      city_id: "10",
      province: "اصفهان",
      city: "کاشان",
      province_id: "10",
    },
    {
      city_id: "11",
      province: "اصفهان",
      city: "گلپايگان",
      province_id: "10",
    },
    {
      city_id: "12",
      province: "اصفهان",
      city: "لنجان",
      province_id: "10",
    },
    {
      city_id: "17",
      province: "اصفهان",
      city: "مبارکه",
      province_id: "10",
    },
    {
      city_id: "13",
      province: "اصفهان",
      city: "نايين",
      province_id: "10",
    },
    {
      city_id: "14",
      province: "اصفهان",
      city: "نجف آباد",
      province_id: "10",
    },
    {
      city_id: "15",
      province: "اصفهان",
      city: "نطنز",
      province_id: "10",
    },
    {
      city_id: "05",
      province: "البرز",
      city: "اشتهارد",
      province_id: "30",
    },
    {
      city_id: "02",
      province: "البرز",
      city: "ساوجبلاغ",
      province_id: "30",
    },
    {
      city_id: "04",
      province: "البرز",
      city: "طالقان",
      province_id: "30",
    },
    {
      city_id: "06",
      province: "البرز",
      city: "فرديس",
      province_id: "30",
    },
    {
      city_id: "01",
      province: "البرز",
      city: "کرج",
      province_id: "30",
    },
    {
      city_id: "03",
      province: "البرز",
      city: "نظرآباد",
      province_id: "30",
    },
    {
      city_id: "01",
      province: "ايلام",
      city: "ايلام",
      province_id: "16",
    },
    {
      city_id: "07",
      province: "ايلام",
      city: "ايوان",
      province_id: "16",
    },
    {
      city_id: "06",
      province: "ايلام",
      city: "آبدانان",
      province_id: "16",
    },
    {
      city_id: "10",
      province: "ايلام",
      city: "بدره",
      province_id: "16",
    },
    {
      city_id: "04",
      province: "ايلام",
      city: "چرداول",
      province_id: "16",
    },
    {
      city_id: "02",
      province: "ايلام",
      city: "دره شهر",
      province_id: "16",
    },
    {
      city_id: "03",
      province: "ايلام",
      city: "دهلران",
      province_id: "16",
    },
    {
      city_id: "09",
      province: "ايلام",
      city: "سيروان",
      province_id: "16",
    },
    {
      city_id: "08",
      province: "ايلام",
      city: "ملكشاهی",
      province_id: "16",
    },
    {
      city_id: "05",
      province: "ايلام",
      city: "مهران",
      province_id: "16",
    },
    {
      city_id: "11",
      province: "ايلام",
      city: "هلیلان",
      province_id: "16",
    },
    {
      city_id: "22",
      province: "آذربايجان شرقی",
      city: "اسکو",
      province_id: "03",
    },
    {
      city_id: "02",
      province: "آذربايجان شرقی",
      city: "اهر",
      province_id: "03",
    },
    {
      city_id: "21",
      province: "آذربايجان شرقی",
      city: "آذرشهر",
      province_id: "03",
    },
    {
      city_id: "13",
      province: "آذربايجان شرقی",
      city: "بستان آباد",
      province_id: "03",
    },
    {
      city_id: "12",
      province: "آذربايجان شرقی",
      city: "بناب",
      province_id: "03",
    },
    {
      city_id: "03",
      province: "آذربايجان شرقی",
      city: "تبريز",
      province_id: "03",
    },
    {
      city_id: "19",
      province: "آذربايجان شرقی",
      city: "جلفا",
      province_id: "03",
    },
    {
      city_id: "23",
      province: "آذربايجان شرقی",
      city: "چاراويماق",
      province_id: "03",
    },
    {
      city_id: "26",
      province: "آذربايجان شرقی",
      city: "خداآفرين",
      province_id: "03",
    },
    {
      city_id: "05",
      province: "آذربايجان شرقی",
      city: "سراب",
      province_id: "03",
    },
    {
      city_id: "14",
      province: "آذربايجان شرقی",
      city: "شبستر",
      province_id: "03",
    },
    {
      city_id: "25",
      province: "آذربايجان شرقی",
      city: "عجب شير",
      province_id: "03",
    },
    {
      city_id: "15",
      province: "آذربايجان شرقی",
      city: "کليبر",
      province_id: "03",
    },
    {
      city_id: "06",
      province: "آذربايجان شرقی",
      city: "مراغه",
      province_id: "03",
    },
    {
      city_id: "07",
      province: "آذربايجان شرقی",
      city: "مرند",
      province_id: "03",
    },
    {
      city_id: "20",
      province: "آذربايجان شرقی",
      city: "ملکان",
      province_id: "03",
    },
    {
      city_id: "10",
      province: "آذربايجان شرقی",
      city: "ميانه",
      province_id: "03",
    },
    {
      city_id: "16",
      province: "آذربايجان شرقی",
      city: "هريس",
      province_id: "03",
    },
    {
      city_id: "11",
      province: "آذربايجان شرقی",
      city: "هشترود",
      province_id: "03",
    },
    {
      city_id: "27",
      province: "آذربايجان شرقی",
      city: "هوراند",
      province_id: "03",
    },
    {
      city_id: "24",
      province: "آذربايجان شرقی",
      city: "ورزقان",
      province_id: "03",
    },
    {
      city_id: "01",
      province: "آذربايجان غربی",
      city: "اروميه",
      province_id: "04",
    },
    {
      city_id: "13",
      province: "آذربايجان غربی",
      city: "اشنويه",
      province_id: "04",
    },
    {
      city_id: "10",
      province: "آذربايجان غربی",
      city: "بوكان",
      province_id: "04",
    },
    {
      city_id: "15",
      province: "آذربايجان غربی",
      city: "پلدشت",
      province_id: "04",
    },
    {
      city_id: "02",
      province: "آذربايجان غربی",
      city: "پيرانشهر",
      province_id: "04",
    },
    {
      city_id: "12",
      province: "آذربايجان غربی",
      city: "تكاب",
      province_id: "04",
    },
    {
      city_id: "14",
      province: "آذربايجان غربی",
      city: "چالدران",
      province_id: "04",
    },
    {
      city_id: "16",
      province: "آذربايجان غربی",
      city: "چايپاره",
      province_id: "04",
    },
    {
      city_id: "03",
      province: "آذربايجان غربی",
      city: "خوی",
      province_id: "04",
    },
    {
      city_id: "04",
      province: "آذربايجان غربی",
      city: "سردشت",
      province_id: "04",
    },
    {
      city_id: "05",
      province: "آذربايجان غربی",
      city: "سلماس",
      province_id: "04",
    },
    {
      city_id: "11",
      province: "آذربايجان غربی",
      city: "شاهين دژ",
      province_id: "04",
    },
    {
      city_id: "17",
      province: "آذربايجان غربی",
      city: "شوط",
      province_id: "04",
    },
    {
      city_id: "06",
      province: "آذربايجان غربی",
      city: "ماكو",
      province_id: "04",
    },
    {
      city_id: "07",
      province: "آذربايجان غربی",
      city: "مهاباد",
      province_id: "04",
    },
    {
      city_id: "08",
      province: "آذربايجان غربی",
      city: "مياندوآب",
      province_id: "04",
    },
    {
      city_id: "09",
      province: "آذربايجان غربی",
      city: "نقده",
      province_id: "04",
    },
    {
      city_id: "01",
      province: "بوشهر",
      city: "بوشهر",
      province_id: "18",
    },
    {
      city_id: "02",
      province: "بوشهر",
      city: "تنگستان",
      province_id: "18",
    },
    {
      city_id: "09",
      province: "بوشهر",
      city: "جم",
      province_id: "18",
    },
    {
      city_id: "03",
      province: "بوشهر",
      city: "دشتستان",
      province_id: "18",
    },
    {
      city_id: "04",
      province: "بوشهر",
      city: "دشتی",
      province_id: "18",
    },
    {
      city_id: "05",
      province: "بوشهر",
      city: "دير",
      province_id: "18",
    },
    {
      city_id: "08",
      province: "بوشهر",
      city: "ديلم",
      province_id: "18",
    },
    {
      city_id: "10",
      province: "بوشهر",
      city: "عسلويه",
      province_id: "18",
    },
    {
      city_id: "06",
      province: "بوشهر",
      city: "كنگان",
      province_id: "18",
    },
    {
      city_id: "07",
      province: "بوشهر",
      city: "گناوه",
      province_id: "18",
    },
    {
      city_id: "10",
      province: "تهران",
      city: "اسلامشهر",
      province_id: "23",
    },
    {
      city_id: "19",
      province: "تهران",
      city: "بهارستان",
      province_id: "23",
    },
    {
      city_id: "13",
      province: "تهران",
      city: "پاكدشت",
      province_id: "23",
    },
    {
      city_id: "20",
      province: "تهران",
      city: "پرديس",
      province_id: "23",
    },
    {
      city_id: "18",
      province: "تهران",
      city: "پيشوا",
      province_id: "23",
    },
    {
      city_id: "01",
      province: "تهران",
      city: "تهران",
      province_id: "23",
    },
    {
      city_id: "02",
      province: "تهران",
      city: "دماوند",
      province_id: "23",
    },
    {
      city_id: "12",
      province: "تهران",
      city: "رباط کريم",
      province_id: "23",
    },
    {
      city_id: "03",
      province: "تهران",
      city: "ری",
      province_id: "23",
    },
    {
      city_id: "04",
      province: "تهران",
      city: "شميرانات",
      province_id: "23",
    },
    {
      city_id: "09",
      province: "تهران",
      city: "شهريار",
      province_id: "23",
    },
    {
      city_id: "14",
      province: "تهران",
      city: "فيروزكوه",
      province_id: "23",
    },
    {
      city_id: "16",
      province: "تهران",
      city: "قدس",
      province_id: "23",
    },
    {
      city_id: "21",
      province: "تهران",
      city: "قرچک",
      province_id: "23",
    },
    {
      city_id: "17",
      province: "تهران",
      city: "ملارد",
      province_id: "23",
    },
    {
      city_id: "06",
      province: "تهران",
      city: "ورامين",
      province_id: "23",
    },
    {
      city_id: "05",
      province: "چهارمحال وبختياری",
      city: "اردل",
      province_id: "14",
    },
    {
      city_id: "01",
      province: "چهارمحال وبختياری",
      city: "بروجن",
      province_id: "14",
    },
    {
      city_id: "09",
      province: "چهارمحال وبختياری",
      city: "بن",
      province_id: "14",
    },
    {
      city_id: "10",
      province: "چهارمحال وبختياری",
      city: "خانميرزا",
      province_id: "14",
    },
    {
      city_id: "08",
      province: "چهارمحال وبختياری",
      city: "سامان",
      province_id: "14",
    },
    {
      city_id: "02",
      province: "چهارمحال وبختياری",
      city: "شهرکرد",
      province_id: "14",
    },
    {
      city_id: "03",
      province: "چهارمحال وبختياری",
      city: "فارسان",
      province_id: "14",
    },
    {
      city_id: "06",
      province: "چهارمحال وبختياری",
      city: "کوهرنگ",
      province_id: "14",
    },
    {
      city_id: "07",
      province: "چهارمحال وبختياری",
      city: "کيار",
      province_id: "14",
    },
    {
      city_id: "04",
      province: "چهارمحال وبختياری",
      city: "لردگان",
      province_id: "14",
    },
    {
      city_id: "08",
      province: "خراسان جنوبی",
      city: "بشرويه",
      province_id: "29",
    },
    {
      city_id: "01",
      province: "خراسان جنوبی",
      city: "بيرجند",
      province_id: "29",
    },
    {
      city_id: "10",
      province: "خراسان جنوبی",
      city: "خوسف",
      province_id: "29",
    },
    {
      city_id: "02",
      province: "خراسان جنوبی",
      city: "درميان",
      province_id: "29",
    },
    {
      city_id: "09",
      province: "خراسان جنوبی",
      city: "زيرکوه",
      province_id: "29",
    },
    {
      city_id: "06",
      province: "خراسان جنوبی",
      city: "سرايان",
      province_id: "29",
    },
    {
      city_id: "03",
      province: "خراسان جنوبی",
      city: "سربيشه",
      province_id: "29",
    },
    {
      city_id: "11",
      province: "خراسان جنوبی",
      city: "طبس",
      province_id: "29",
    },
    {
      city_id: "07",
      province: "خراسان جنوبی",
      city: "فردوس",
      province_id: "29",
    },
    {
      city_id: "04",
      province: "خراسان جنوبی",
      city: "قائنات",
      province_id: "29",
    },
    {
      city_id: "05",
      province: "خراسان جنوبی",
      city: "نهبندان",
      province_id: "29",
    },
    {
      city_id: "37",
      province: "خراسان رضوی",
      city: "باخرز",
      province_id: "09",
    },
    {
      city_id: "31",
      province: "خراسان رضوی",
      city: "بجستان",
      province_id: "09",
    },
    {
      city_id: "23",
      province: "خراسان رضوی",
      city: "بردسكن",
      province_id: "09",
    },
    {
      city_id: "32",
      province: "خراسان رضوی",
      city: "بينالود",
      province_id: "09",
    },
    {
      city_id: "04",
      province: "خراسان رضوی",
      city: "تايباد",
      province_id: "09",
    },
    {
      city_id: "06",
      province: "خراسان رضوی",
      city: "تربت جام",
      province_id: "09",
    },
    {
      city_id: "05",
      province: "خراسان رضوی",
      city: "تربت حيدريه",
      province_id: "09",
    },
    {
      city_id: "34",
      province: "خراسان رضوی",
      city: "جغتای",
      province_id: "09",
    },
    {
      city_id: "36",
      province: "خراسان رضوی",
      city: "جوين",
      province_id: "09",
    },
    {
      city_id: "18",
      province: "خراسان رضوی",
      city: "چناران",
      province_id: "09",
    },
    {
      city_id: "29",
      province: "خراسان رضوی",
      city: "خليل آباد",
      province_id: "09",
    },
    {
      city_id: "19",
      province: "خراسان رضوی",
      city: "خواف",
      province_id: "09",
    },
    {
      city_id: "38",
      province: "خراسان رضوی",
      city: "خوشاب",
      province_id: "09",
    },
    {
      city_id: "39",
      province: "خراسان رضوی",
      city: "داورزن",
      province_id: "09",
    },
    {
      city_id: "07",
      province: "خراسان رضوی",
      city: "درگز",
      province_id: "09",
    },
    {
      city_id: "27",
      province: "خراسان رضوی",
      city: "رشتخوار",
      province_id: "09",
    },
    {
      city_id: "35",
      province: "خراسان رضوی",
      city: "زاوه",
      province_id: "09",
    },
    {
      city_id: "08",
      province: "خراسان رضوی",
      city: "سبزوار",
      province_id: "09",
    },
    {
      city_id: "20",
      province: "خراسان رضوی",
      city: "سرخس",
      province_id: "09",
    },
    {
      city_id: "40",
      province: "خراسان رضوی",
      city: "صالح آباد",
      province_id: "09",
    },
    {
      city_id: "22",
      province: "خراسان رضوی",
      city: "فريمان",
      province_id: "09",
    },
    {
      city_id: "33",
      province: "خراسان رضوی",
      city: "فيروزه",
      province_id: "09",
    },
    {
      city_id: "13",
      province: "خراسان رضوی",
      city: "قوچان",
      province_id: "09",
    },
    {
      city_id: "14",
      province: "خراسان رضوی",
      city: "كاشمر",
      province_id: "09",
    },
    {
      city_id: "28",
      province: "خراسان رضوی",
      city: "كلات",
      province_id: "09",
    },
    {
      city_id: "41",
      province: "خراسان رضوی",
      city: "کوهسرخ",
      province_id: "09",
    },
    {
      city_id: "15",
      province: "خراسان رضوی",
      city: "گناباد",
      province_id: "09",
    },
    {
      city_id: "16",
      province: "خراسان رضوی",
      city: "مشهد",
      province_id: "09",
    },
    {
      city_id: "30",
      province: "خراسان رضوی",
      city: "مه ولات",
      province_id: "09",
    },
    {
      city_id: "17",
      province: "خراسان رضوی",
      city: "نيشابور",
      province_id: "09",
    },
    {
      city_id: "01",
      province: "خراسان شمالی",
      city: "اسفراين",
      province_id: "28",
    },
    {
      city_id: "02",
      province: "خراسان شمالی",
      city: "بجنورد",
      province_id: "28",
    },
    {
      city_id: "03",
      province: "خراسان شمالی",
      city: "جاجرم",
      province_id: "28",
    },
    {
      city_id: "08",
      province: "خراسان شمالی",
      city: "راز و جرگلان",
      province_id: "28",
    },
    {
      city_id: "04",
      province: "خراسان شمالی",
      city: "شيروان",
      province_id: "28",
    },
    {
      city_id: "05",
      province: "خراسان شمالی",
      city: "فاروج",
      province_id: "28",
    },
    {
      city_id: "07",
      province: "خراسان شمالی",
      city: "گرمه",
      province_id: "28",
    },
    {
      city_id: "06",
      province: "خراسان شمالی",
      city: "مانه وسملقان",
      province_id: "28",
    },
    {
      city_id: "16",
      province: "خوزستان",
      city: "اميديه",
      province_id: "06",
    },
    {
      city_id: "21",
      province: "خوزستان",
      city: "انديکا",
      province_id: "06",
    },
    {
      city_id: "02",
      province: "خوزستان",
      city: "انديمشک",
      province_id: "06",
    },
    {
      city_id: "03",
      province: "خوزستان",
      city: "اهواز",
      province_id: "06",
    },
    {
      city_id: "04",
      province: "خوزستان",
      city: "ايذه",
      province_id: "06",
    },
    {
      city_id: "01",
      province: "خوزستان",
      city: "آبادان",
      province_id: "06",
    },
    {
      city_id: "26",
      province: "خوزستان",
      city: "آغاجاری",
      province_id: "06",
    },
    {
      city_id: "15",
      province: "خوزستان",
      city: "باغ ملک",
      province_id: "06",
    },
    {
      city_id: "24",
      province: "خوزستان",
      city: "باوی",
      province_id: "06",
    },
    {
      city_id: "05",
      province: "خوزستان",
      city: "بندرماهشهر",
      province_id: "06",
    },
    {
      city_id: "06",
      province: "خوزستان",
      city: "بهبهان",
      province_id: "06",
    },
    {
      city_id: "25",
      province: "خوزستان",
      city: "حميديه",
      province_id: "06",
    },
    {
      city_id: "07",
      province: "خوزستان",
      city: "خرمشهر",
      province_id: "06",
    },
    {
      city_id: "08",
      province: "خوزستان",
      city: "دزفول",
      province_id: "06",
    },
    {
      city_id: "09",
      province: "خوزستان",
      city: "دشت آزادگان",
      province_id: "06",
    },
    {
      city_id: "19",
      province: "خوزستان",
      city: "رامشير",
      province_id: "06",
    },
    {
      city_id: "10",
      province: "خوزستان",
      city: "رامهرمز",
      province_id: "06",
    },
    {
      city_id: "11",
      province: "خوزستان",
      city: "شادگان",
      province_id: "06",
    },
    {
      city_id: "14",
      province: "خوزستان",
      city: "شوش",
      province_id: "06",
    },
    {
      city_id: "12",
      province: "خوزستان",
      city: "شوشتر",
      province_id: "06",
    },
    {
      city_id: "27",
      province: "خوزستان",
      city: "کارون",
      province_id: "06",
    },
    {
      city_id: "20",
      province: "خوزستان",
      city: "گتوند",
      province_id: "06",
    },
    {
      city_id: "17",
      province: "خوزستان",
      city: "لالی",
      province_id: "06",
    },
    {
      city_id: "13",
      province: "خوزستان",
      city: "مسجدسليمان",
      province_id: "06",
    },
    {
      city_id: "22",
      province: "خوزستان",
      city: "هفتکل",
      province_id: "06",
    },
    {
      city_id: "18",
      province: "خوزستان",
      city: "هنديجان",
      province_id: "06",
    },
    {
      city_id: "23",
      province: "خوزستان",
      city: "هويزه",
      province_id: "06",
    },
    {
      city_id: "01",
      province: "زنجان",
      city: "ابهر",
      province_id: "19",
    },
    {
      city_id: "06",
      province: "زنجان",
      city: "ايجرود",
      province_id: "19",
    },
    {
      city_id: "03",
      province: "زنجان",
      city: "خدابنده",
      province_id: "19",
    },
    {
      city_id: "07",
      province: "زنجان",
      city: "خرمدره",
      province_id: "19",
    },
    {
      city_id: "04",
      province: "زنجان",
      city: "زنجان",
      province_id: "19",
    },
    {
      city_id: "10",
      province: "زنجان",
      city: "سلطانيه",
      province_id: "19",
    },
    {
      city_id: "08",
      province: "زنجان",
      city: "طارم",
      province_id: "19",
    },
    {
      city_id: "09",
      province: "زنجان",
      city: "ماهنشان",
      province_id: "19",
    },
    {
      city_id: "06",
      province: "سمنان",
      city: "آرادان",
      province_id: "20",
    },
    {
      city_id: "01",
      province: "سمنان",
      city: "دامغان",
      province_id: "20",
    },
    {
      city_id: "08",
      province: "سمنان",
      city: "سرخه",
      province_id: "20",
    },
    {
      city_id: "02",
      province: "سمنان",
      city: "سمنان",
      province_id: "20",
    },
    {
      city_id: "03",
      province: "سمنان",
      city: "شاهرود",
      province_id: "20",
    },
    {
      city_id: "04",
      province: "سمنان",
      city: "گرمسار",
      province_id: "20",
    },
    {
      city_id: "05",
      province: "سمنان",
      city: "مهدئ شهر",
      province_id: "20",
    },
    {
      city_id: "07",
      province: "سمنان",
      city: "ميامی",
      province_id: "20",
    },
    {
      city_id: "01",
      province: "سيستان وبلوچستان",
      city: "ايرانشهر",
      province_id: "11",
    },
    {
      city_id: "20",
      province: "سيستان وبلوچستان",
      city: "بمپور",
      province_id: "11",
    },
    {
      city_id: "21",
      province: "سيستان وبلوچستان",
      city: "تفتان",
      province_id: "11",
    },
    {
      city_id: "02",
      province: "سيستان وبلوچستان",
      city: "چاه بهار",
      province_id: "11",
    },
    {
      city_id: "03",
      province: "سيستان وبلوچستان",
      city: "خاش",
      province_id: "11",
    },
    {
      city_id: "22",
      province: "سيستان وبلوچستان",
      city: "دشتیاری",
      province_id: "11",
    },
    {
      city_id: "12",
      province: "سيستان وبلوچستان",
      city: "دلگان",
      province_id: "11",
    },
    {
      city_id: "08",
      province: "سيستان وبلوچستان",
      city: "راسک",
      province_id: "11",
    },
    {
      city_id: "04",
      province: "سيستان وبلوچستان",
      city: "زابل",
      province_id: "11",
    },
    {
      city_id: "05",
      province: "سيستان وبلوچستان",
      city: "زاهدان",
      province_id: "11",
    },
    {
      city_id: "10",
      province: "سيستان وبلوچستان",
      city: "زهک",
      province_id: "11",
    },
    {
      city_id: "06",
      province: "سيستان وبلوچستان",
      city: "سراوان",
      province_id: "11",
    },
    {
      city_id: "23",
      province: "سيستان وبلوچستان",
      city: "سرباز",
      province_id: "11",
    },
    {
      city_id: "14",
      province: "سيستان وبلوچستان",
      city: "سيب و سوران",
      province_id: "11",
    },
    {
      city_id: "19",
      province: "سيستان وبلوچستان",
      city: "فنوج",
      province_id: "11",
    },
    {
      city_id: "18",
      province: "سيستان وبلوچستان",
      city: "قصرقند",
      province_id: "11",
    },
    {
      city_id: "09",
      province: "سيستان وبلوچستان",
      city: "کنارک",
      province_id: "11",
    },
    {
      city_id: "13",
      province: "سيستان وبلوچستان",
      city: "مهرستان",
      province_id: "11",
    },
    {
      city_id: "17",
      province: "سيستان وبلوچستان",
      city: "ميرجاوه",
      province_id: "11",
    },
    {
      city_id: "07",
      province: "سيستان وبلوچستان",
      city: "نيک شهر",
      province_id: "11",
    },
    {
      city_id: "15",
      province: "سيستان وبلوچستان",
      city: "نيمروز",
      province_id: "11",
    },
    {
      city_id: "16",
      province: "سيستان وبلوچستان",
      city: "هامون",
      province_id: "11",
    },
    {
      city_id: "11",
      province: "سيستان وبلوچستان",
      city: "هيرمند",
      province_id: "11",
    },
    {
      city_id: "17",
      province: "فارس",
      city: "ارسنجان",
      province_id: "07",
    },
    {
      city_id: "02",
      province: "فارس",
      city: "استهبان",
      province_id: "07",
    },
    {
      city_id: "03",
      province: "فارس",
      city: "اقليد",
      province_id: "07",
    },
    {
      city_id: "36",
      province: "فارس",
      city: "اوز",
      province_id: "07",
    },
    {
      city_id: "01",
      province: "فارس",
      city: "آباده",
      province_id: "07",
    },
    {
      city_id: "35",
      province: "فارس",
      city: "بختگان",
      province_id: "07",
    },
    {
      city_id: "16",
      province: "فارس",
      city: "بوانات",
      province_id: "07",
    },
    {
      city_id: "31",
      province: "فارس",
      city: "بیضا",
      province_id: "07",
    },
    {
      city_id: "23",
      province: "فارس",
      city: "پاسارگاد",
      province_id: "07",
    },
    {
      city_id: "04",
      province: "فارس",
      city: "جهرم",
      province_id: "07",
    },
    {
      city_id: "29",
      province: "فارس",
      city: "خرامه",
      province_id: "07",
    },
    {
      city_id: "18",
      province: "فارس",
      city: "خرم بيد",
      province_id: "07",
    },
    {
      city_id: "34",
      province: "فارس",
      city: "خفر",
      province_id: "07",
    },
    {
      city_id: "24",
      province: "فارس",
      city: "خنج",
      province_id: "07",
    },
    {
      city_id: "05",
      province: "فارس",
      city: "داراب",
      province_id: "07",
    },
    {
      city_id: "26",
      province: "فارس",
      city: "رستم",
      province_id: "07",
    },
    {
      city_id: "30",
      province: "فارس",
      city: "زرقان",
      province_id: "07",
    },
    {
      city_id: "19",
      province: "فارس",
      city: "زرين دشت",
      province_id: "07",
    },
    {
      city_id: "06",
      province: "فارس",
      city: "سپيدان",
      province_id: "07",
    },
    {
      city_id: "32",
      province: "فارس",
      city: "سرچهان",
      province_id: "07",
    },
    {
      city_id: "25",
      province: "فارس",
      city: "سروستان",
      province_id: "07",
    },
    {
      city_id: "07",
      province: "فارس",
      city: "شيراز",
      province_id: "07",
    },
    {
      city_id: "22",
      province: "فارس",
      city: "فراشبند",
      province_id: "07",
    },
    {
      city_id: "08",
      province: "فارس",
      city: "فسا",
      province_id: "07",
    },
    {
      city_id: "09",
      province: "فارس",
      city: "فيروزآباد",
      province_id: "07",
    },
    {
      city_id: "20",
      province: "فارس",
      city: "قيروکارزين",
      province_id: "07",
    },
    {
      city_id: "10",
      province: "فارس",
      city: "کازرون",
      province_id: "07",
    },
    {
      city_id: "28",
      province: "فارس",
      city: "کوار",
      province_id: "07",
    },
    {
      city_id: "33",
      province: "فارس",
      city: "کوه چنار",
      province_id: "07",
    },
    {
      city_id: "27",
      province: "فارس",
      city: "گراش",
      province_id: "07",
    },
    {
      city_id: "11",
      province: "فارس",
      city: "لارستان",
      province_id: "07",
    },
    {
      city_id: "15",
      province: "فارس",
      city: "لامرد",
      province_id: "07",
    },
    {
      city_id: "12",
      province: "فارس",
      city: "مرودشت",
      province_id: "07",
    },
    {
      city_id: "13",
      province: "فارس",
      city: "ممسنی",
      province_id: "07",
    },
    {
      city_id: "21",
      province: "فارس",
      city: "مهر",
      province_id: "07",
    },
    {
      city_id: "14",
      province: "فارس",
      city: "ني ريز",
      province_id: "07",
    },
    {
      city_id: "05",
      province: "قزوين",
      city: "البرز",
      province_id: "26",
    },
    {
      city_id: "04",
      province: "قزوين",
      city: "آبيك",
      province_id: "26",
    },
    {
      city_id: "06",
      province: "قزوين",
      city: "آوج",
      province_id: "26",
    },
    {
      city_id: "01",
      province: "قزوين",
      city: "بوئين زهرا",
      province_id: "26",
    },
    {
      city_id: "02",
      province: "قزوين",
      city: "تاكستان",
      province_id: "26",
    },
    {
      city_id: "03",
      province: "قزوين",
      city: "قزوين",
      province_id: "26",
    },
    {
      city_id: "01",
      province: "قم",
      city: "قم",
      province_id: "25",
    },
    {
      city_id: "01",
      province: "كردستان",
      city: "بانه",
      province_id: "12",
    },
    {
      city_id: "02",
      province: "كردستان",
      city: "بيجار",
      province_id: "12",
    },
    {
      city_id: "10",
      province: "كردستان",
      city: "دهگلان",
      province_id: "12",
    },
    {
      city_id: "07",
      province: "كردستان",
      city: "ديواندره",
      province_id: "12",
    },
    {
      city_id: "09",
      province: "كردستان",
      city: "سروآباد",
      province_id: "12",
    },
    {
      city_id: "03",
      province: "كردستان",
      city: "سقز",
      province_id: "12",
    },
    {
      city_id: "04",
      province: "كردستان",
      city: "سنندج",
      province_id: "12",
    },
    {
      city_id: "05",
      province: "كردستان",
      city: "قروه",
      province_id: "12",
    },
    {
      city_id: "08",
      province: "كردستان",
      city: "كامياران",
      province_id: "12",
    },
    {
      city_id: "06",
      province: "كردستان",
      city: "مريوان",
      province_id: "12",
    },
    {
      city_id: "23",
      province: "كرمان",
      city: "ارزوئيه",
      province_id: "08",
    },
    {
      city_id: "20",
      province: "كرمان",
      city: "انار",
      province_id: "08",
    },
    {
      city_id: "01",
      province: "كرمان",
      city: "بافت",
      province_id: "08",
    },
    {
      city_id: "10",
      province: "كرمان",
      city: "بردسير",
      province_id: "08",
    },
    {
      city_id: "02",
      province: "كرمان",
      city: "بم",
      province_id: "08",
    },
    {
      city_id: "03",
      province: "كرمان",
      city: "جيرفت",
      province_id: "08",
    },
    {
      city_id: "18",
      province: "كرمان",
      city: "رابر",
      province_id: "08",
    },
    {
      city_id: "11",
      province: "كرمان",
      city: "راور",
      province_id: "08",
    },
    {
      city_id: "04",
      province: "كرمان",
      city: "رفسنجان",
      province_id: "08",
    },
    {
      city_id: "15",
      province: "كرمان",
      city: "رودبارجنوب",
      province_id: "08",
    },
    {
      city_id: "17",
      province: "كرمان",
      city: "ريگان",
      province_id: "08",
    },
    {
      city_id: "05",
      province: "كرمان",
      city: "زرند",
      province_id: "08",
    },
    {
      city_id: "06",
      province: "كرمان",
      city: "سيرجان",
      province_id: "08",
    },
    {
      city_id: "07",
      province: "كرمان",
      city: "شهربابك",
      province_id: "08",
    },
    {
      city_id: "12",
      province: "كرمان",
      city: "عنبرآباد",
      province_id: "08",
    },
    {
      city_id: "22",
      province: "كرمان",
      city: "فارياب",
      province_id: "08",
    },
    {
      city_id: "19",
      province: "كرمان",
      city: "فهرج",
      province_id: "08",
    },
    {
      city_id: "16",
      province: "كرمان",
      city: "قلعه گنج",
      province_id: "08",
    },
    {
      city_id: "08",
      province: "كرمان",
      city: "كرمان",
      province_id: "08",
    },
    {
      city_id: "09",
      province: "كرمان",
      city: "كهنوج",
      province_id: "08",
    },
    {
      city_id: "14",
      province: "كرمان",
      city: "كوهبنان",
      province_id: "08",
    },
    {
      city_id: "13",
      province: "كرمان",
      city: "منوجان",
      province_id: "08",
    },
    {
      city_id: "21",
      province: "كرمان",
      city: "نرماشير",
      province_id: "08",
    },
    {
      city_id: "07",
      province: "كهگيلويه وبويراحمد",
      city: "باشت",
      province_id: "17",
    },
    {
      city_id: "05",
      province: "كهگيلويه وبويراحمد",
      city: "بهمئی",
      province_id: "17",
    },
    {
      city_id: "01",
      province: "كهگيلويه وبويراحمد",
      city: "بويراحمد",
      province_id: "17",
    },
    {
      city_id: "06",
      province: "كهگيلويه وبويراحمد",
      city: "چرام",
      province_id: "17",
    },
    {
      city_id: "04",
      province: "كهگيلويه وبويراحمد",
      city: "دنا",
      province_id: "17",
    },
    {
      city_id: "02",
      province: "كهگيلويه وبويراحمد",
      city: "كهگيلويه",
      province_id: "17",
    },
    {
      city_id: "03",
      province: "كهگيلويه وبويراحمد",
      city: "گچساران",
      province_id: "17",
    },
    {
      city_id: "08",
      province: "كهگيلويه وبويراحمد",
      city: "لنده",
      province_id: "17",
    },
    {
      city_id: "09",
      province: "كهگيلويه وبويراحمد",
      city: "مارگون",
      province_id: "17",
    },
    {
      city_id: "01",
      province: "کرمانشاه",
      city: "اسلام آبادغرب",
      province_id: "05",
    },
    {
      city_id: "03",
      province: "کرمانشاه",
      city: "پاوه",
      province_id: "05",
    },
    {
      city_id: "12",
      province: "کرمانشاه",
      city: "ثلاث باباجانی",
      province_id: "05",
    },
    {
      city_id: "09",
      province: "کرمانشاه",
      city: "جوانرود",
      province_id: "05",
    },
    {
      city_id: "13",
      province: "کرمانشاه",
      city: "دالاهو",
      province_id: "05",
    },
    {
      city_id: "14",
      province: "کرمانشاه",
      city: "روانسر",
      province_id: "05",
    },
    {
      city_id: "04",
      province: "کرمانشاه",
      city: "سرپل ذهاب",
      province_id: "05",
    },
    {
      city_id: "05",
      province: "کرمانشاه",
      city: "سنقر",
      province_id: "05",
    },
    {
      city_id: "10",
      province: "کرمانشاه",
      city: "صحنه",
      province_id: "05",
    },
    {
      city_id: "06",
      province: "کرمانشاه",
      city: "قصرشيرين",
      province_id: "05",
    },
    {
      city_id: "02",
      province: "کرمانشاه",
      city: "کرمانشاه",
      province_id: "05",
    },
    {
      city_id: "07",
      province: "کرمانشاه",
      city: "کنگاور",
      province_id: "05",
    },
    {
      city_id: "08",
      province: "کرمانشاه",
      city: "گيلانغرب",
      province_id: "05",
    },
    {
      city_id: "11",
      province: "کرمانشاه",
      city: "هرسين",
      province_id: "05",
    },
    {
      city_id: "10",
      province: "گلستان",
      city: "آزادشهر",
      province_id: "27",
    },
    {
      city_id: "08",
      province: "گلستان",
      city: "آق قلا",
      province_id: "27",
    },
    {
      city_id: "01",
      province: "گلستان",
      city: "بندرگز",
      province_id: "27",
    },
    {
      city_id: "02",
      province: "گلستان",
      city: "تركمن",
      province_id: "27",
    },
    {
      city_id: "11",
      province: "گلستان",
      city: "راميان",
      province_id: "27",
    },
    {
      city_id: "03",
      province: "گلستان",
      city: "علي آباد کتول",
      province_id: "27",
    },
    {
      city_id: "04",
      province: "گلستان",
      city: "كردكوی",
      province_id: "27",
    },
    {
      city_id: "09",
      province: "گلستان",
      city: "كلاله",
      province_id: "27",
    },
    {
      city_id: "14",
      province: "گلستان",
      city: "گاليكش",
      province_id: "27",
    },
    {
      city_id: "05",
      province: "گلستان",
      city: "گرگان",
      province_id: "27",
    },
    {
      city_id: "13",
      province: "گلستان",
      city: "گميشان",
      province_id: "27",
    },
    {
      city_id: "06",
      province: "گلستان",
      city: "گنبدكاووس",
      province_id: "27",
    },
    {
      city_id: "12",
      province: "گلستان",
      city: "مراوه تپه",
      province_id: "27",
    },
    {
      city_id: "07",
      province: "گلستان",
      city: "مينودشت",
      province_id: "27",
    },
    {
      city_id: "13",
      province: "گيلان",
      city: "املش",
      province_id: "01",
    },
    {
      city_id: "01",
      province: "گيلان",
      city: "آستارا",
      province_id: "01",
    },
    {
      city_id: "02",
      province: "گيلان",
      city: "آستانه اشرفيه",
      province_id: "01",
    },
    {
      city_id: "03",
      province: "گيلان",
      city: "بندرانزلی",
      province_id: "01",
    },
    {
      city_id: "05",
      province: "گيلان",
      city: "رشت",
      province_id: "01",
    },
    {
      city_id: "14",
      province: "گيلان",
      city: "رضوانشهر",
      province_id: "01",
    },
    {
      city_id: "06",
      province: "گيلان",
      city: "رودبار",
      province_id: "01",
    },
    {
      city_id: "07",
      province: "گيلان",
      city: "رودسر",
      province_id: "01",
    },
    {
      city_id: "15",
      province: "گيلان",
      city: "سياهكل",
      province_id: "01",
    },
    {
      city_id: "12",
      province: "گيلان",
      city: "شفت",
      province_id: "01",
    },
    {
      city_id: "08",
      province: "گيلان",
      city: "صومعه سرا",
      province_id: "01",
    },
    {
      city_id: "04",
      province: "گيلان",
      city: "طوالش",
      province_id: "01",
    },
    {
      city_id: "09",
      province: "گيلان",
      city: "فومن",
      province_id: "01",
    },
    {
      city_id: "11",
      province: "گيلان",
      city: "لاهيجان",
      province_id: "01",
    },
    {
      city_id: "10",
      province: "گيلان",
      city: "لنگرود",
      province_id: "01",
    },
    {
      city_id: "16",
      province: "گيلان",
      city: "ماسال",
      province_id: "01",
    },
    {
      city_id: "07",
      province: "لرستان",
      city: "ازنا",
      province_id: "15",
    },
    {
      city_id: "01",
      province: "لرستان",
      city: "اليگودرز",
      province_id: "15",
    },
    {
      city_id: "02",
      province: "لرستان",
      city: "بروجرد",
      province_id: "15",
    },
    {
      city_id: "08",
      province: "لرستان",
      city: "پلدختر",
      province_id: "15",
    },
    {
      city_id: "10",
      province: "لرستان",
      city: "چگنی",
      province_id: "15",
    },
    {
      city_id: "03",
      province: "لرستان",
      city: "خرم آباد",
      province_id: "15",
    },
    {
      city_id: "04",
      province: "لرستان",
      city: "دلفان",
      province_id: "15",
    },
    {
      city_id: "05",
      province: "لرستان",
      city: "دورود",
      province_id: "15",
    },
    {
      city_id: "11",
      province: "لرستان",
      city: "رومشکان",
      province_id: "15",
    },
    {
      city_id: "09",
      province: "لرستان",
      city: "سلسله",
      province_id: "15",
    },
    {
      city_id: "06",
      province: "لرستان",
      city: "کوهدشت",
      province_id: "15",
    },
    {
      city_id: "01",
      province: "مازندران",
      city: "آمل",
      province_id: "02",
    },
    {
      city_id: "02",
      province: "مازندران",
      city: "بابل",
      province_id: "02",
    },
    {
      city_id: "16",
      province: "مازندران",
      city: "بابلسر",
      province_id: "02",
    },
    {
      city_id: "04",
      province: "مازندران",
      city: "بهشهر",
      province_id: "02",
    },
    {
      city_id: "05",
      province: "مازندران",
      city: "تنكابن",
      province_id: "02",
    },
    {
      city_id: "21",
      province: "مازندران",
      city: "جويبار",
      province_id: "02",
    },
    {
      city_id: "20",
      province: "مازندران",
      city: "چالوس",
      province_id: "02",
    },
    {
      city_id: "06",
      province: "مازندران",
      city: "رامسر",
      province_id: "02",
    },
    {
      city_id: "07",
      province: "مازندران",
      city: "ساری",
      province_id: "02",
    },
    {
      city_id: "08",
      province: "مازندران",
      city: "سوادكوه",
      province_id: "02",
    },
    {
      city_id: "27",
      province: "مازندران",
      city: "سوادکوه شمالی",
      province_id: "02",
    },
    {
      city_id: "26",
      province: "مازندران",
      city: "سيمرغ",
      province_id: "02",
    },
    {
      city_id: "24",
      province: "مازندران",
      city: "عباس آباد",
      province_id: "02",
    },
    {
      city_id: "23",
      province: "مازندران",
      city: "فريدونكنار",
      province_id: "02",
    },
    {
      city_id: "10",
      province: "مازندران",
      city: "قائم شهر",
      province_id: "02",
    },
    {
      city_id: "28",
      province: "مازندران",
      city: "کلاردشت",
      province_id: "02",
    },
    {
      city_id: "22",
      province: "مازندران",
      city: "گلوگاه",
      province_id: "02",
    },
    {
      city_id: "18",
      province: "مازندران",
      city: "محمودآباد",
      province_id: "02",
    },
    {
      city_id: "25",
      province: "مازندران",
      city: "مياندورود",
      province_id: "02",
    },
    {
      city_id: "19",
      province: "مازندران",
      city: "نكا",
      province_id: "02",
    },
    {
      city_id: "14",
      province: "مازندران",
      city: "نور",
      province_id: "02",
    },
    {
      city_id: "15",
      province: "مازندران",
      city: "نوشهر",
      province_id: "02",
    },
    {
      city_id: "01",
      province: "مرکزی",
      city: "اراک",
      province_id: "00",
    },
    {
      city_id: "02",
      province: "مرکزی",
      city: "آشتيان",
      province_id: "00",
    },
    {
      city_id: "03",
      province: "مرکزی",
      city: "تفرش",
      province_id: "00",
    },
    {
      city_id: "04",
      province: "مرکزی",
      city: "خمين",
      province_id: "00",
    },
    {
      city_id: "12",
      province: "مرکزی",
      city: "خنداب",
      province_id: "00",
    },
    {
      city_id: "05",
      province: "مرکزی",
      city: "دليجان",
      province_id: "00",
    },
    {
      city_id: "10",
      province: "مرکزی",
      city: "زرنديه",
      province_id: "00",
    },
    {
      city_id: "06",
      province: "مرکزی",
      city: "ساوه",
      province_id: "00",
    },
    {
      city_id: "07",
      province: "مرکزی",
      city: "شازند",
      province_id: "00",
    },
    {
      city_id: "13",
      province: "مرکزی",
      city: "فراهان",
      province_id: "00",
    },
    {
      city_id: "11",
      province: "مرکزی",
      city: "کميجان",
      province_id: "00",
    },
    {
      city_id: "09",
      province: "مرکزی",
      city: "محلات",
      province_id: "00",
    },
    {
      city_id: "01",
      province: "هرمزگان",
      city: "ابوموسی",
      province_id: "22",
    },
    {
      city_id: "09",
      province: "هرمزگان",
      city: "بستك",
      province_id: "22",
    },
    {
      city_id: "13",
      province: "هرمزگان",
      city: "بشاگرد",
      province_id: "22",
    },
    {
      city_id: "02",
      province: "هرمزگان",
      city: "بندرعباس",
      province_id: "22",
    },
    {
      city_id: "03",
      province: "هرمزگان",
      city: "بندرلنگه",
      province_id: "22",
    },
    {
      city_id: "11",
      province: "هرمزگان",
      city: "پارسيان",
      province_id: "22",
    },
    {
      city_id: "06",
      province: "هرمزگان",
      city: "جاسك",
      province_id: "22",
    },
    {
      city_id: "08",
      province: "هرمزگان",
      city: "حاجي اباد",
      province_id: "22",
    },
    {
      city_id: "10",
      province: "هرمزگان",
      city: "خمير",
      province_id: "22",
    },
    {
      city_id: "07",
      province: "هرمزگان",
      city: "رودان",
      province_id: "22",
    },
    {
      city_id: "12",
      province: "هرمزگان",
      city: "سيريك",
      province_id: "22",
    },
    {
      city_id: "04",
      province: "هرمزگان",
      city: "قشم",
      province_id: "22",
    },
    {
      city_id: "05",
      province: "هرمزگان",
      city: "ميناب",
      province_id: "22",
    },
    {
      city_id: "06",
      province: "همدان",
      city: "اسدآباد",
      province_id: "13",
    },
    {
      city_id: "07",
      province: "همدان",
      city: "بهار",
      province_id: "13",
    },
    {
      city_id: "01",
      province: "همدان",
      city: "تويسركان",
      province_id: "13",
    },
    {
      city_id: "10",
      province: "همدان",
      city: "درگزین",
      province_id: "13",
    },
    {
      city_id: "08",
      province: "همدان",
      city: "رزن",
      province_id: "13",
    },
    {
      city_id: "09",
      province: "همدان",
      city: "فامنين",
      province_id: "13",
    },
    {
      city_id: "05",
      province: "همدان",
      city: "كبودرآهنگ",
      province_id: "13",
    },
    {
      city_id: "02",
      province: "همدان",
      city: "ملاير",
      province_id: "13",
    },
    {
      city_id: "03",
      province: "همدان",
      city: "نهاوند",
      province_id: "13",
    },
    {
      city_id: "04",
      province: "همدان",
      city: "همدان",
      province_id: "13",
    },
    {
      city_id: "07",
      province: "يزد",
      city: "ابركوه",
      province_id: "21",
    },
    {
      city_id: "01",
      province: "يزد",
      city: "اردكان",
      province_id: "21",
    },
    {
      city_id: "08",
      province: "يزد",
      city: "اشکذر",
      province_id: "21",
    },
    {
      city_id: "02",
      province: "يزد",
      city: "بافق",
      province_id: "21",
    },
    {
      city_id: "11",
      province: "يزد",
      city: "بهاباد",
      province_id: "21",
    },
    {
      city_id: "03",
      province: "يزد",
      city: "تفت",
      province_id: "21",
    },
    {
      city_id: "09",
      province: "يزد",
      city: "خاتم",
      province_id: "21",
    },
    {
      city_id: "04",
      province: "يزد",
      city: "مهريز",
      province_id: "21",
    },
    {
      city_id: "06",
      province: "يزد",
      city: "ميبد",
      province_id: "21",
    },
    {
      city_id: "05",
      province: "يزد",
      city: "يزد",
      province_id: "21",
    },
  ],
};
